/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Hotel } from './Hotel';
import {
    HotelFromJSON,
    HotelFromJSONTyped,
    HotelToJSON,
    HotelToJSONTyped,
} from './Hotel';

/**
 * 
 * @export
 * @interface HotelStayRequest
 */
export interface HotelStayRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelStayRequest
     */
    userId: string;
    /**
     * 
     * @type {Hotel}
     * @memberof HotelStayRequest
     */
    hotelStay: Hotel;
    /**
     * 
     * @type {string}
     * @memberof HotelStayRequest
     */
    ledgerSource: HotelStayRequestLedgerSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof HotelStayRequest
     */
    placeId?: string;
}


/**
 * @export
 */
export const HotelStayRequestLedgerSourceEnum = {
    User: 'USER',
    UserManual: 'USER_MANUAL',
    EmailParser: 'EMAIL_PARSER',
    GondolaReservation: 'GONDOLA_RESERVATION',
    ReservationScraper: 'RESERVATION_SCRAPER'
} as const;
export type HotelStayRequestLedgerSourceEnum = typeof HotelStayRequestLedgerSourceEnum[keyof typeof HotelStayRequestLedgerSourceEnum];


/**
 * Check if a given object implements the HotelStayRequest interface.
 */
export function instanceOfHotelStayRequest(value: object): value is HotelStayRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('hotelStay' in value) || value['hotelStay'] === undefined) return false;
    if (!('ledgerSource' in value) || value['ledgerSource'] === undefined) return false;
    return true;
}

export function HotelStayRequestFromJSON(json: any): HotelStayRequest {
    return HotelStayRequestFromJSONTyped(json, false);
}

export function HotelStayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelStayRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'hotelStay': HotelFromJSON(json['hotel_stay']),
        'ledgerSource': json['ledger_source'],
        'placeId': json['place_id'] == null ? undefined : json['place_id'],
    };
}

export function HotelStayRequestToJSON(json: any): HotelStayRequest {
    return HotelStayRequestToJSONTyped(json, false);
}

export function HotelStayRequestToJSONTyped(value?: HotelStayRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'hotel_stay': HotelToJSON(value['hotelStay']),
        'ledger_source': value['ledgerSource'],
        'place_id': value['placeId'],
    };
}

